import { useState } from "react";
import { toast } from "sonner";
import { Store } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useAuth } from "@/context/AuthContext";
import { useOnline } from "@/lib/connectivity";

export function BranchSwitcher() {
  const { session, switchBranch } = useAuth();
  const online = useOnline();
  const [busy, setBusy] = useState(false);
  const branches = session.branches || [];
  if (branches.length <= 1) {
    return (
      <div className="flex h-10 min-w-0 items-center gap-1.5 rounded-lg bg-white/5 px-2.5 text-sm font-semibold text-slate-200" data-testid="branch-label">
        <Store className="h-4 w-4 shrink-0 text-amber-400" /> <span className="truncate">{session.branch.name}</span>
      </div>
    );
  }
  const change = async (id) => {
    setBusy(true);
    await switchBranch(id);
    setBusy(false);
    toast.success(`Switched to ${branches.find((b) => b.id === id)?.name}`);
  };
  return (
    <Select value={session.branch.id} onValueChange={change} disabled={busy || !online}>
      <SelectTrigger className="h-10 w-auto min-w-[44px] max-w-[190px] gap-1.5 border-white/10 bg-white/5 text-sm font-semibold text-white focus:ring-amber-400" data-testid="branch-switcher">
        <Store className="h-4 w-4 shrink-0 text-amber-400" />
        <span className="hidden truncate sm:inline"><SelectValue /></span>
      </SelectTrigger>
      <SelectContent>
        {branches.map((b) => (
          <SelectItem key={b.id} value={b.id} data-testid={`branch-option-${b.code}`}>{b.name}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
